{
  "entities": {
    "warehouses": "Gudang | Gudang",
    "loadtypes": "Jenis Muatan | Jenis Muatan",
    "organizations": "Organisasi | Organisasi",
    "orgs": "Org | Org"
  }
}
